import {Component, OnInit, ViewChild} from '@angular/core';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {CardActivationImport} from '../../../dto/card-activation-import';
import {DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {DateFormats} from '../../../providers/app-date-adapter';
import {CardActivationImportService} from '../../services/card-activation-import.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {FileImportDialogComponent} from '../../../shared/file-import-dialog/file-import-dialog.component';
import {RoleService} from '../../../services/role.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-card-activation-imports',
  templateUrl: './card-activation-imports.component.html',
  styleUrls: ['./card-activation-imports.component.css']
})
export class CardActivationImportsComponent implements OnInit {
  dataSource = new MultiCrudDataSource(this.importService);

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  constructor(
    private importService: CardActivationImportService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
  ) { }

  columns = [
    { columnDef: 'id',              header: 'id',      cell: (row: CardActivationImport) => `${row.id}`},
    { columnDef: 'date',            header: 'Date',    cell: (row: CardActivationImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime )}`},
    { columnDef: 'userId',          header: 'User',    cell: (row: CardActivationImport) => `${row.username}`},
    { columnDef: 'ipAddress',       header: 'Ip address',   cell: (row: CardActivationImport) => `${row.ipAddress}`},
    { columnDef: 'totalRowCount',   header: 'Total rows',   cell: (row: CardActivationImport) => `${row.totalRowCount}`},
    { columnDef: 'warningRowCount', header: 'Warning rows', cell: (row: CardActivationImport) => `${row.warningRowCount}`},
    { columnDef: 'invalidRowCount', header: 'Invalid rows', cell: (row: CardActivationImport) => `${row.invalidRowCount}`},
  ];
  ngOnInit() {
  }

  onUpload(file) {
    this.importService.upload(file)
      .subscribe(result => {
        this.dataSource.data.push(result);
        this.table.refreshTable();

        this.dialog.open(FileImportDialogComponent, {
          data: {
            import: result,
            link: this.router.url + '/' + result.id.toString()
          },
          maxWidth: 400,
        });
      });
  }

  gotoImport(id: number) {
    this.router.navigate([id], { relativeTo: this.route });
  }

  getRowClass = (item: CardActivationImport): string => {
    if ( item.criticalRowCount > 0 ) {
      return 'critical-row';
    }
    if ( item.invalidRowCount > 0 ) {
      return 'error-row';
    }
    if ( item.warningRowCount > 0 ) {
      return 'warning-row';
    }
    if ( item.infoRowCount > 0 ) {
      return 'info-row';
    }

    return '';
  };

  getViewLink = (item: CardActivationImport): string => item.id.toString();
  deleteEnabled() {
    return this.roleService.hasRoles( 'admin' );
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( ['admin'] );
  }

}
